import axios from "axios";

// export const API_URL = 'http://172.16.3.249:3050/';
export const API_UPLOADS_URL = 'http://172.16.3.249:3050';

export const API_URL = 'https://misgtg.tretyakov.ru/api/';
// export const API_UPLOADS_URL = 'https://missite.tretyakov.ru';
export const $api = axios.create({
    baseURL: API_URL,
    // withCredentials: true,
})

$api.interceptors.request.use((config) => {
    if (config.headers) {
        config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
        config.headers.Language = localStorage.getItem('language') || 'ru'
    }
    return config;
})

export const testApi = {
    async test() {
        return $api.get('/test')
    }
}

